function normalizeRegistrySearch(value) {
    return String(value || '')
        .trim()
        .toLocaleLowerCase('ru')
        .replace(/ё/g, 'е')
        .replace(/[«»"]/g, '')
        .replace(/[^a-zа-я0-9]+/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

function registrySearchWords(query) {
    return normalizeRegistrySearch(query).split(' ').filter(Boolean);
}

function employeeRegistryMatchesSearch(employee, words) {
    if (!words.length) return true;
    const period = employee.latest_employment_period || {};
    const contacts = (employee.contact_methods || []).map(contact => (
        [contact.label, contact.value, contact.normalized_value].filter(Boolean).join(' ')
    )).join(' ');
    const haystack = normalizeRegistrySearch([
        employee.employee_id,
        employee.user_id,
        employee.display_name,
        employee.full_name,
        employee.department_name,
        employee.position,
        employee.citizenship,
        period.personnel_number,
        period.official_position,
        period.official_department_name,
        period.source_organization_name,
        employee.telegram_contact && employee.telegram_contact.username,
        contacts
    ].filter(Boolean).join(' '));
    return words.every(word => haystack.includes(word));
}

module.exports = {normalizeRegistrySearch, registrySearchWords, employeeRegistryMatchesSearch};
